import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { AuthenticationService } from '../../../user/services/authentication.service';
import { IChannelByPhone } from '../../interfaces/IChannel';
import { IDealerSetting } from '../../interfaces/IDealerSettings';
import { WorkspaceShorter } from '../../interfaces/IWorkspace';
import { ChannelsService } from '../../services/channels.service';
import { PermissionsService } from '../../services/permissions.service';
import { SmartRepliesService } from '../../services/smart-replies.service';
import { MessagingTranslationService } from '../../services/translations.service';
import { WorkspacesService } from '../../services/workspaces.service';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-messaging-chat',
  templateUrl: './ngx-messaging-chat.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MessagingChatComponent {
  @Input() channelByPhone: IChannelByPhone;
  @Input() channelUID: string;
  @Input() workspace: WorkspaceShorter;
  @Input() dealerSettings: IDealerSetting[] = [];
  @Input() canUseCache = false;
  @Input() displayName: string;
  @Input() messagesStartDate: Date;
  @Output() linkClicked = new EventEmitter<boolean>();
  @Output() orderIdEvent = new EventEmitter<string>();
  constructor(
    public store: Store<AppStateWithChat>,
    public permissionService: PermissionsService,
    public workspaceService: WorkspacesService,
    public authService: AuthenticationService,
    public translationService: MessagingTranslationService,
    public smartRepliesService: SmartRepliesService,
    public channelsService: ChannelsService
  ) {}

  handleLinkClick(data: boolean) {
    this.linkClicked.emit(data);
  }

  emitOrderIdEvent(event: string): void {
    this.orderIdEvent.emit(event);
  }
}
